import * as types from '../../action-types';
import { connectToPlaid as initialState } from "../../initialState";

const connectToPlaid = (state=initialState, action) => {
  switch (action.type) {
    case types.CONNECT_TO_PLAID_START:
      return {
        ...state,
        isLoading: true
      };
    case types.CONNECT_TO_PLAID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.CONNECT_TO_PLAID_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.CONNECT_TO_PLAID_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default connectToPlaid;
